// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// AccountOperationRequestMessage
/// </summary>
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class AccountOperationRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_ACCOUNT_OPERATION_REQUEST_MESSAGE, fieldSet);
    }
    assetId(assetId) {
        this.setFieldValue(FieldsFactory.FIELD_ASSET_ID, assetId);
    }
    setOperationType(operationType, serverMaxField) {
        if (serverMaxField >= FieldsFactory.FIELD_OPERATION_TYPE2) {
            this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE2, operationType);
        }
        else {
            this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE, operationType);
        }
    }
    setAccountId(accountId) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    setCounterId(counterId) {
        if (counterId) // #114179
         {
            this.setFieldValue(FieldsFactory.FIELD_COUNTER_ID, counterId);
        }
    }
    setAmount(amount) {
        this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
    }
    setComment(comment) {
        this.setFieldValue(FieldsFactory.FIELD_COMMENT, comment);
    }
}
